<template>
  <div
    class="
      chat-header
      tw-flex
      tw-justify-between
      tw-items-center
      tw-bg-white
      tw-border-b
      tw-h-16
      tw-z-50
      tw-text-primary
      tw-px-4
      tw-gap-2
    "
  >
    <div class="tw-flex tw-gap-2 tw-items-center">
      <img
        class="tw-w-min tw-h-6"
        :src="require('@/assets/logo-villa-mobile.svg')"
        alt="villa logo"
      />
      <p class="tw-text-lg tw-font-bold tw-select-none">Villa Chat Systems</p>
      <div class="tw-ml-4 tw-flex tw-space-x-2">
        <router-link
          v-if="$route.name !== 'Chat'"
          to="/chat"
          class="
            tw-border tw-px-4 tw-py-1 tw-rounded-md
            hover:tw-bg-primary hover:tw-text-white
          "
          >Chat</router-link
        >
        <router-link
          v-if="$route.name !== 'Dashboard'"
          to="/dashboard"
          class="
            tw-border tw-px-4 tw-py-1 tw-rounded-md
            hover:tw-bg-primary hover:tw-text-white
          "
        >
          Dashboard
        </router-link>
      </div>
    </div>
    <div class="tw-flex tw-gap-2 tw-items-center">
      <p v-if="user" class="tw-font-bold">Hi, {{ user.username || check }}</p>
      <button
        class="
          tw-border
          tw-px-4
          tw-py-1
          tw-rounded-md
          tw-h-min
          tw-text-white
          tw-bg-primary
          hover:tw-bg-primary-light
        "
        @click="onSignOut"
      >
        Sign Out
      </button>
    </div>
  </div>
</template>

<script>
import Auth from "@aws-amplify/auth";
export default {
  name: "ChatHeader",
  computed: {
    user() {
      return this.$store.getters["chat/user"];
    },
  },
  methods: {
    async onSignOut() {
      console.log("onSignOut");
      await Auth.signOut();
      this.$router.replace("/auth", (err) => {
        console.log(err, "ignored");
      });
    },
  },
  filters: {
    check(value) {
      if (!value) return "";
      if ("username" in value) return value.username || "";
    },
  },
};
</script>

<style>

</style>
